import { render, staticRenderFns } from "./aRmsYearSales.vue?vue&type=template&id=2ca9a996"
import script from "./aRmsYearSales.vue?vue&type=script&lang=js"
export * from "./aRmsYearSales.vue?vue&type=script&lang=js"
import style0 from "./aRmsYearSales.vue?vue&type=style&index=0&id=2ca9a996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VIcon,VSkeletonLoader,VTooltip})
